module.exports = __webpack_public_path__ + "static/assets/ae21bd02fff4276409bea90e620da158.png";